/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { AbstractCheckboxListElement } from './abstract-checkbox-list-element.component';
import { CheckboxListModelService } from './checkbox-list-model.service';

@Component({
	selector: 'checkbox-list-item',
	templateUrl: './checkbox-list-item.component.html',
	styleUrls: ['./checkbox-list-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxListItemComponent extends AbstractCheckboxListElement implements OnInit, OnDestroy {
	private _id: string;

	constructor(checkboxListModel: CheckboxListModelService) {
		super(checkboxListModel);
	}

	@Input() public set id(newId: string) {
		if (!this._id) {
			this._id = newId;
		} else {
			console.error("Checkbox list's id cannot be dynamically be re-assigned");
		}
	}

	protected createFormControl() {
		const checkboxData = this.checkboxListModel.currentMapOfValues.get(this._id);
		this.checkboxFormControl = new FormControl<boolean>(checkboxData ? checkboxData.isChecked : false);
	}

	protected handleCheckboxChange(newCheckboxValue: boolean) {
		this.checkboxListModel.setItemValue(this._id, newCheckboxValue);
	}

	protected finishComponentInitialization() {
		// Check that the surrounding list's FormControl value's Map includes an entry whose ID
		// equals this item's ID:
		if (!this.checkboxListModel.includesId(this._id)) {
			console.error("Checkbox list's model does not include item's id: " + this._id);
		} else {
			// When the model is changed such that this checkbox's value changes, update the checkbox:
			this.checkboxListModel
				.getItemIsCheckedChange$(this._id)
				.pipe(takeUntil(this.shutdownSubject$))
				.subscribe((isChecked) => {
					if (isChecked !== this.checkboxFormControl.value) {
						this.checkboxFormControl.setValue(isChecked, { emitEvent: false });
					}
				});
		}
	}
}
